import axios from "axios";

export const getApis = (clientId) => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/AtsApi/getApis/" + clientId)
    .then((res) => res.data);
};

export const addApi = (newApi) => {
  return axios.post(import.meta.env.VITE_BACKEND_API + "/api/AtsApi/addApi/", newApi).then((res) => res.data);
};

export const editApi = (editedApi) => {
  return axios
    .put(import.meta.env.VITE_BACKEND_API + "/api/AtsApi/editApi/", editedApi)
    .then((res) => res.data);
};

export const deleteApi = (apiId) => {
  return axios
    .delete(import.meta.env.VITE_BACKEND_API + "/api/AtsApi/deleteApi/" + apiId)
    .then((res) => res.data);
};
